<template>
	<div id="commonPage">
		<section>
			<div class="topBox">
				<div class="contentBox">
					<div class="notice" v-if="false">
						<p>案件通知：江泰指挥中心邀请您参与以下案件报价，请您在30分钟内进行报价，逾期将视为放弃此案件的报价</p>
						<ul>
							<p>尚未报价案件类型：</p>
							<li v-for='(item,index) in case_list' :key=index  @click="tocase(item.id)" v-if="waitingList[item.id] != 0">
								{{item.name}}
								({{waitingList[item.id]}})
							</li>
						</ul>
					</div>
					<serviceCase :case_list=case_list :num_list=num_list :routePath="'RegAwait'"></serviceCase>
				</div>
			</div>
			<div class="centerBox">
				<div class="contentBox">
					<div class="top">
						<span :class="{active:caseIndex == 1}" @click="caseIndex = 1">进行中案件（{{nowCaseArr.length}}）</span>
						<span class="line"></span>
						<span :class="{active:caseIndex == 2}" @click="caseIndex = 2">近期完成案件（{{completeCaseArr.length}}）</span>
					</div>
					<div v-show="caseIndex == 1">
						<div class="content" v-if="nowCaseArr.length != 0">
							<vcase v-for='(item,index) in nowCaseArr' :key=index :nowCaseItem=item :btnText="1" :keyIndex=index></vcase>
						</div>
						<div class="content" v-else>
							<div class="kongBox">
								<img src="./../commonPage/img/kong.png">
								<p>当前暂无数据哦～</p>
							</div>
						</div>
					</div>
					<div v-show="caseIndex == 2">
						<div class="content" v-if="completeCaseArr.length != 0">
							<vcase v-for='(item,index) in completeCaseArr' :key=index :nowCaseItem=item :btnText="2" :keyIndex=index></vcase>
						</div>
						<div class="content" v-else>
							<div class="kongBox">
								<img src="./../commonPage/img/kong.png">
								<p>当前暂无数据哦～</p>
							</div>
						</div>
					</div>

				</div>

			</div>
		</section>
		<vfooter></vfooter>
		<!--<workbench v-show='workbenchShow'></workbench>-->
	</div>
</template>

<script>
	import vcase from '@/views/commonPage/case'
	import vfooter from './footer'
	import serviceCase from '@/views/commonPage/service'
	import constants from "@/util/constants.js";
	import workbench from '@/views/commonPage/workbench'
	import { seversList,getnowCaseRegulator,getCaseNum1,getCompleteCase,getwaitingCaseNum } from '@/views/axios/api.js';
	export default{
		data(){
			return {
				insti:this.$route.params.insti || JSON.parse(window.localStorage.getItem("insti")),//头部数据
				token:this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data,
				caseIndex:1,//切换进行中，还是近期完成
				case_list:[],//icon
				nowCaseArr:[],//进行中的案件
				num_list:[],
				completeCaseArr:[],//已完成的案件
				waitingList:[],//等待
				workbenchShow:true
			}
		},
		components:{
			vcase,
			vfooter,
			workbench,
			serviceCase
		},
		mounted(){
			this.getSeverFun();
			this.getnowCase();
			this.getCaseNum();
			this.getCompleteCase();
			// this.getwaitingCaseNum()
		},
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		watch:{
			languageIndex(){
				this.getnowCase();
				this.getCompleteCase()
			}
		},
		methods:{
			getSeverFun(){//门急诊就医
				var data={
			        token:this.token,
					parentId:0
				}
				seversList(data)
				.then(res=>{
					this.case_list=res.data.obj
				})
				.catch(err=>{
					console.log(err)
				})
			},
			getnowCase(){//当前案件管理
				var data={
			        token:this.token
				}
				getnowCaseRegulator(data)
				.then(res=>{
			        this.nowCaseArr=this.formattingData(res)
				})
				.catch(err=>{
					console.log(err)
				})
			},
			formattingData(data){
				var caseArr=[]
		        data.data.obj.map(v => {
		          var objNew = {};
		          objNew.name = v.obj.victimList[0].obj.victimName
              objNew.caseNo=v.obj.obj.caseNo
		          objNew.contact = v.obj.obj.reporterContact;
		          objNew.typename = v.obj.incidentTypeStr;
		          objNew.typenameEn = v.obj.incidentTypeStrEn;
		          objNew.caseState = v.obj.obj.caseState;
		          objNew.solutionState = v.obj.solutionState;
		          objNew.typeId = v.obj.obj.incidentType;
		          objNew.op = constants.state2op(v.obj.obj.caseState);
		          objNew.id=v.obj.obj.id
		          if (v.obj.contractType == 1) {
		            objNew.contractTypeName = "大包";
		          } else if (v.obj.contractType == 2) {
		            objNew.contractTypeName = "小包";
		          } else if (v.obj.contractType == 3) {
		            objNew.contractTypeName = "纯服务";
		          }
		          //计算总耗时
		          objNew.alltime = this.timeToStr(v.obj2.operation[v.obj2.operation.length - 1].obj.updateAt);
		          objNew.tableData = [];
				  if(this.languageIndex == 0){
					  v.obj2.operation.map(o => {
						objNew.tableData.push({
						  oper: o.instiName + "账号:" + o.passport, //操作方
						  node: o.obj.opDesc, //操作节点
						  detail: o.obj.opStateText, //操作细节
						  nstate: "已完成", //当前状态
						  time: constants.time(o.obj.updateAt) //时间
						});
					  });
				  }else{
					  v.obj2.operation.map(o => {
						objNew.tableData.push({
						  oper: o.instiNameEn + " Account number：" + o.passport, //操作方
						  node: o.obj.opDescEn ? o.obj.opDescEn : o.obj.opDesc, //操作节点
						  detail: o.obj.opStateTextEn, //操作细节
						  nstate: "Completed", //当前状态
						  time: constants.time(o.obj.updateAt) //时间
						});
					  });
				  }

		          objNew.serviceLst = [];
		          objNew.serviceIndex = 0;
              if(v.obj2.serviceLst){
 		          v.obj2.serviceLst.map(o => {
		            objNew.serviceLst.push({
		              name: o.dict.name, //结点名称
		              nameEn: o.dict.nameEn, //结点名称
		              state: o.obj.state
		            });
		            if (o.obj.state && o.obj.state == 1) {
		              objNew.serviceIndex += 1;
		            }
		          });               
              }


		         	caseArr.push(objNew);
		        });
		        return caseArr
			},
		    timeToStr(time) {//时间转换
		      var timeNow = new Date().getTime();
		      var date3 = timeNow - time;
		      //计算出相差天数
		      var days = Math.floor(date3 / (24 * 3600 * 1000));
		      //计算出小时数
		      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
		      var hours = Math.floor(leave1 / (3600 * 1000));
		      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
		      var minutes = Math.floor(leave2 / (60 * 1000));
		      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
		      var seconds = Math.round(leave3 / 1000);
//		      return days + "天 " + hours + "小时 " + minutes + " 分钟";
		      return days + "天 " + hours + "小时 ";
			},
			tocase(id) {
				let token = this.token;
				let insti = this.insti;
				let name = "";
				console.log(this.case_list);
				this.case_list.map(v => {
					if(v.id == id) {
						name = v.name;
					}
				});
				window.localStorage.setItem(
					"case",
					JSON.stringify({
						case: "RegAwait"
					})
				);
				this.$router.push({
					name: "RegAwait",
					params: {
						token: token,
						insti: insti,
						flag: false
					},
					query: {
						typeId: id,
						name: name
					}
				});
			},
			getCaseNum(){//获取类别数量
				var data={
			        token:this.token
				}
				getCaseNum1(data)
				.then(res=>{
					this.num_list = res.data.obj;
					console.log(this.num_list)
				})
				.catch(err=>{
					console.log(err)
				})
			},
			getCompleteCase(){//获取完成案件
				var data={
			        token:this.token
				}
				getCompleteCase(data)
				.then(res=>{
					this.completeCaseArr = this.formattingData(res)
				})
				.catch(err=>{
					console.log(err)
				})
			},
			getwaitingCaseNum(){
				var data={
			        token:this.token
				}
				getwaitingCaseNum(data)
				.then(res=>{
					this.waitingList = res.data.obj;
				})
				.catch(err=>{
					console.log(err)
				})
			}
		}
}
</script>

<style scoped="scoped">
	.topBox{padding: 50px 0;background-color: white;}
	.contentBox{width: 1200px;margin: 0 auto;}
	.topBox .notice{border: 1px solid #ffba00;border-radius: 3px;padding: 15px;}
	.topBox .notice >p{background: url('./../commonPage/img/laba.png') no-repeat center left;padding-left: 30px;color: #ff7200;}
	.topBox .notice ul{overflow: hidden;margin-top: 20px;}
	.topBox .notice ul *{float: left;margin-right: 20px;}
	.topBox .notice ul p{color: #666;padding-left: 30px;}
	.topBox .notice ul li{color: #00abfa;cursor: pointer;}
	.topBox .list{padding-top:40px;overflow: hidden;padding-bottom: 10px;}
	.topBox .list li{width:calc((100% - 366px)/6);border:1px solid #eee;height: 250px;border-radius: 3px;padding: 0 25px;padding-top: 40px;text-align: left;float: left;margin-right: 10px;cursor: pointer;}
	.topBox .list li:last-child{margin-right: 0;}
	.topBox .list li >img{margin: 0 auto;display: block;margin-bottom: 20px;}
	.topBox .list li h3{font-size: 18px;}
	.topBox .list li p{font-size: 14px;color: #666;margin-top: 20px;line-height: 20px;height: 20px;overflow: hidden;transition:all 0.3s}
	.topBox .list li .manage .arrow{height: 30px;width: 30px;background: url('./../commonPage/img/weixuanzhong.png') no-repeat center center;margin: 0 auto;margin-top: 40px;}
	.topBox .list li:hover .manage .arrow{background: url('./../commonPage/img/active.png') no-repeat center center;margin-left: 60%;}
	.topBox .list li .manage{position: relative;}
	.topBox .list li .manage p{position: absolute;top: 0;margin-top: 0;left: 20%;color: #00abfa;display: none;}
	.topBox .list li:hover{box-shadow: 4px 8px 10px rgba(0,171,250,0.2);}
	.topBox .list li:hover p{height: 60px;}
	.topBox .list li:hover .manage{margin-top: 10px;}
	.topBox .list li:hover .manage p{display: block;margin-top: 7px;}


	.centerBox{background-color:#f8fafe;padding: 20px 0;}
	.centerBox .top{text-align: center;padding-bottom: 30px;}
	.centerBox .top span{padding: 0 10px;font-size: 20px;color: #333;cursor: pointer;line-height: 50px;display: inline-block;vertical-align: middle;}
	.centerBox .top span:first-child{margin-right: 10px;}
	.centerBox .top span:last-child{margin-left: 10px;}
	.centerBox .top span.active{color: #00abfa;border-bottom: 2px solid #00abfa;}
	.centerBox .top span.line{background-color: rgba(0,0,0,0.1);width: 1.5px;height: 50px;padding: 0;}
	.centerBox .kongBox{text-align: center;padding: 160px 0;}
	.centerBox .kongBox p{color: #666;line-height: 40px;}
</style>



// WEBPACK FOOTER //
// src/views/regulator/mainPase.vue